@defer {
	<div class="flex flex-col gap-12 py-24 lg:py-32 px-8 lg:px-32">

		<div class="flex flex-col gap-16 justify-center">

			<div class="font-notosans flex flex-col md:flex-row justify-center items-center md:justify-end gap-4">
				<a href="/bet/matches" class="w-fit text-center bg-peps-gold text-peps-dark-700 font-semibold text-sm px-5 py-2 cursor-pointer hover:bg-peps-yellow transition-colors uppercase items-center flex">
					<span>{{ 'page.leaderboard.make-prediction' | translate }}</span>
				</a>

				<div class="relative text-right">
					<button
						(click)="toggleOpen()"
						class="text-white bg-peps-dark-600 font-medium text-sm px-5 py-2.5 text-center inline-flex items-center cursor-pointer"
						type="button">
						{{ selectedYear ?? ('page.leaderboard.season' | translate) }}
						<svg
							class="w-2.5 h-2.5 ms-3 transform duration-300"
							aria-hidden="true"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 10 6"
							[ngClass]="{ 'rotate-180': isOpen, 'rotate-0': !isOpen }">
							<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4" />
						</svg>
					</button>

					@if (isOpen) {
						<div class="absolute right-0 z-10 mt-1 w-fit shadow-sm bg-peps-dark-600 max-h-64 overflow-y-auto custom-vertical-scrollbar">
							<ul class="py-1 text-sm text-peps-dark-200">
								@for (year of years; track year) {
									<li>
										<button
											class="w-full text-left block px-6 py-2 hover:bg-peps-dark-500 cursor-pointer"
											[ngClass]="{ 'bg-peps-gold/70': selectedYear === year }"
											(click)="selectYear(year)"
										>
											{{ year }}
										</button>
									</li>
								}
							</ul>
						</div>
					}
				</div>
			</div>

			<peps-bet-leaderboard-podium [podium]="podium"></peps-bet-leaderboard-podium>

			@if (leaderboards.length > 0) {
				<div class="flex flex-col w-full md:w-3/4 lg:w-1/2 md:mx-auto">
					<div class="w-full overflow-x-auto custom-scrollbar">
						<table class="min-w-[300px] w-full max-w-full text-sm font-notosans border-separate border-spacing-y-2">
							<thead>
								<tr class="text-peps-dark-200/60 uppercase text-xs">
									<td class="px-2 py-1.5 lg:px-6 lg:py-3 text-left">{{ 'page.leaderboard.rank' | translate }}</td>
									<td class="px-2 py-1.5 lg:px-6 lg:py-3 text-left min-w-[140px]">{{ 'page.leaderboard.username' | translate }}</td>
									<td class="px-4 py-2 text-right">{{ 'page.leaderboard.points' | translate }}</td>
								</tr>
							</thead>
							<tbody>
								@for (leaderboard of leaderboards; track leaderboard.user.username) {
									<tr class="w-full bg-peps-dark-600 text-peps-dark-200/90">
										<td class="px-2 py-1.5 lg:px-6 lg:py-3 text-peps-dark-200/80">
											<div class="flex flex-row gap-2 items-center">
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-5 text-peps-dark-100">
													<path fill-rule="evenodd" d="M5.166 2.621v.858c-1.035.148-2.059.33-3.071.543a.75.75 0 0 0-.584.859 6.753 6.753 0 0 0 6.138 5.6 6.73 6.73 0 0 0 2.743 1.346A6.707 6.707 0 0 1 9.279 15H8.54c-1.036 0-1.875.84-1.875 1.875V19.5h-.75a2.25 2.25 0 0 0-2.25 2.25c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-2.25-2.25h-.75v-2.625c0-1.036-.84-1.875-1.875-1.875h-.739a6.706 6.706 0 0 1-1.112-3.173 6.73 6.73 0 0 0 2.743-1.347 6.753 6.753 0 0 0 6.139-5.6.75.75 0 0 0-.585-.858 47.077 47.077 0 0 0-3.07-.543V2.62a.75.75 0 0 0-.658-.744 49.22 49.22 0 0 0-6.093-.377c-2.063 0-4.096.128-6.093.377a.75.75 0 0 0-.657.744Zm0 2.629c0 1.196.312 2.32.857 3.294A5.266 5.266 0 0 1 3.16 5.337a45.6 45.6 0 0 1 2.006-.343v.256Zm13.5 0v-.256c.674.1 1.343.214 2.006.343a5.265 5.265 0 0 1-2.863 3.207 6.72 6.72 0 0 0 .857-3.294Z" clip-rule="evenodd" />
												</svg>
												<span>{{ leaderboard.user.rank }}</span>
											</div>
										</td>
										<td class="px-2 py-1.5 lg:px-6 lg:py-3 text-left" [ngClass]="{ 'text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]': currentUsername === leaderboard.user.username }">
											{{ leaderboard.user.username }}
										</td>
										<td class="px-4 py-3 text-right font-medium transition-transform duration-200">
											<span class="font-notosans">
												<span class="text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)] text-lg">{{ leaderboard.points }}</span>
												<span class="text-peps-dark-200/60 uppercase text-xs">{{ 'page.leaderboard.pts' | translate }}</span>
											</span>
										</td>
									</tr>
								}
							</tbody>
						</table>
					</div>
					<peps-page-selector
						[page]="page"
						[totalPages]="totalPages"
						(pageChange)="onPageChange($event)"
						[goToTop]="false"
					></peps-page-selector>
				</div>
			}

		</div>
	</div>
}
